//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import SalarySettlementsCreateView from '@/views/HumanResource/HrSalarySettlement/HrSalarySettlementCreate'
import SalarySettlementsListView from '@/views/HumanResource/HrSalarySettlement/HrSalarySettlementList'
import SalarySettlementsUpdateView from '@/views/HumanResource/HrSalarySettlement/HrSalarySettlementUpdate'

//
export default {
    path: 'salary_settlement',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'salary-settlement-list',
            component: SalarySettlementsListView,
        },
        {
            path: 'create',
            name: 'salary-settlement-create',
            component: SalarySettlementsCreateView,
            meta: {
                title: 'Crear liquidación de sueldo',
            },
        },
        {
            path: ':id',
            name: 'salary-settlement-update',
            component: SalarySettlementsUpdateView,
            meta: {
                title: 'Detalle de liquidación de sueldo',
            },
        },
    ],
    meta: {
        title: 'Liquidaciones de sueldo',
    },
}
